import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, X } from "lucide-react";

const STORAGE_KEY = "betmebro:beta-banner-dismissed-v1";

export function BetaBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(localStorage.getItem(STORAGE_KEY) !== "1");
  }, []);

  if (import.meta.env.VITE_BETA_BANNER === "false") return null;
  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return (
    <div
      role="status"
      className="bg-warning/10 border-b border-warning/30 text-warning-dark"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-3 text-sm">
        <AlertTriangle
          className="w-4 h-4 shrink-0 text-warning-dark"
          aria-hidden="true"
        />
        <p className="flex-1 leading-snug">
          <span className="font-bold uppercase tracking-[0.1em] text-[11px]">
            {t("betaBanner.label")}
          </span>
          <span className="mx-2 text-warning/60" aria-hidden="true">
            —
          </span>
          <span>{t("betaBanner.body")}</span>
        </p>
        <button
          type="button"
          onClick={dismiss}
          aria-label={t("betaBanner.dismiss")}
          className="shrink-0 p-1 rounded hover:bg-warning/15 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
